<template>

	<div class="gray-bg" style="min-height: 100vh">
		<div class="middle-box text-center loginscreen animated fadeInDown">

      <h3>Payment Gateway</h3>

      <!-- <div>
        {{ paymentDetail }}
      </div> -->

      <TemplateFeedback ref="pageFeedback" />

      <button
        class="btn btn-sm btn-white btn-block m-t"
        v-on:click="paymentCancelClick" >
        Cancel
      </button>

      <button 
        v-show="paymentDetail"
        class="btn btn-sm btn-white btn-block m-t"
        v-on:click="paymentPaidClick" >
        Pay
      </button>

    </div>
  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

export default {
  name: "PageBillPayment",
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Collection' },
        { name: 'Bill' },
      ],

      paymentDetail: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.paymentDetail = [];
    // this.loadBill();
  },
  methods: {
    loadBill() {
      let collectionID = this.$route.query.collectionID;
      if(!collectionID) {
        this.$refs['pageFeedback'].setFeedbackError('Invalid bill.');
        return;
      }

      let feedbackItem = 'bill collection';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/collections/' + collectionID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.paymentDetail = response.data;
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    paymentCancelClick() {
      window.paymentCallback(false);
      window.close();
    },
    paymentPaidClick() {
      window.paymentCallback(true);
      window.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageBillPayment.vue